import { INVITATION_STATUSES } from "../constants/constants";
import { serverTimestamp } from "../firebase";
import { Company } from "../redux/slices/authSlice";
import {
  addDocument,
  getCompanyDocuments,
  getDocuments,
  update,
  deleteDocument,
} from "./firestoreServices";
import { JoinRequest } from "../types/types";
import { USERS_COLLECTION } from "../constants/collections";

export const checkInvitation = async (email: string) => {
  const invitations = await getDocuments("invitations", {
    where: [{ field: "email", operator: "==", value: email }],
    limit: 1,
  });
  if (invitations.length === 0) {
    return false;
  }
  return invitations[0];
};

export const updateInvitation = (id: string) =>
  update("invitations", id, {
    status: INVITATION_STATUSES.ACCEPTED,
    updatedAt: serverTimestamp(),
  });

export const getInvitations = () =>
  getCompanyDocuments("invitations", {
    where: [
      {
        field: "status",
        operator: "==",
        value: INVITATION_STATUSES.PENDING,
      },
    ],
  });

export const getEmployees = () => getCompanyDocuments(USERS_COLLECTION);

export const addInvitation = (
  email: string,
  company: Company,
  role: string,
) => {
  return addDocument(
    { name: "invitations" },
    {
      email,
      createdAt: new Date(),
      updatedAt: new Date(),
      companyId: company.id,
      companyName: company.name,
      role,
      companyType: company.type,
      status: INVITATION_STATUSES.PENDING,
      deleted: false,
    },
  );
};

export const updateRequest = (
  request: JoinRequest,
  company: Company,
  role: string,
) => {
  update("joinRequests", request.id, { status: "ACCEPTED" }).then(() => {
    return update(USERS_COLLECTION, request.userId, {
      company,
      companyId: company.id,
      role: role,
    });
  });
};

//todo updateRequest merge with this
export const declineRequest = (request: JoinRequest) => {
  return update("joinRequests", request.id, { status: "DECLINED" });
};

export const deleteEmployee = async (employeeId: string) => {
  try {
    // Instead of hard deleting, we'll mark the employee as deleted
    // This follows the pattern used throughout the app where deleted: false filters are applied
    await update(USERS_COLLECTION, employeeId, { 
      deleted: true,
      deletedAt: serverTimestamp()
    });
    console.log(`Employee with ID ${employeeId} marked as deleted`);
  } catch (error) {
    console.error(`Failed to delete employee with ID ${employeeId}:`, error);
    throw error;
  }
};
